import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { TalentCertificate } from "../../talents/talentAPI";

type Props = {
  label: string;
  certificate: TalentCertificate;
};

const DocumentState = ({ label, certificate }: Props) => {
  const [state, setState] = useState({ label: "", color: "" });

  const { t } = useTranslation("workRights");

  useEffect(() => {
    const hasDocuments = !!certificate?.documents?.length;
    const isApproved = certificate?.approvedAt;
    const isRejected = certificate?.rejectedAt;

    // TODO: translate
    if (!hasDocuments) {
      setState({ label: t("documentMissing"), color: "error.main" });
    }
    if (hasDocuments && !isApproved && !isRejected) {
      setState({
        label: t("documentSubmittedWaitingApproval"),
        color: "info.main",
      });
    }
    if (hasDocuments && isApproved) {
      setState({
        label: t("documentSubmittedApproved"),
        color: "success.main",
      });
    }
    if (hasDocuments && isRejected) {
      setState({
        label: t("documentSubmittedRejected"),
        color: "error.main",
      });
    }
  }, [certificate, t]);

  return (
    <Box display="flex" mb={2}>
      <Typography sx={{ minWidth: "80px", textTransform: "capitalize" }}>
        {label}
      </Typography>
      <Box display="flex" alignItems="center" gap="0.5rem">
        <Box
          bgcolor={state.color}
          sx={{ width: "8px", height: "8px", borderRadius: "100%" }}
        />
        <Typography sx={{ minWidth: "80px" }}>{state.label}</Typography>
      </Box>
    </Box>
  );
};

export default DocumentState;
